/* Office Walker 2A — step + calorie calculator.
   steps    = round( paceKmh * hours * 1320 / 10 ) * 10   (paceKmh: slow 2, easy 3)
   calories = round( MET * weight * hours )                (MET: slow 2.0, easy 2.8) */
(function () {
  'use strict';
  function fmt(n) { return n.toLocaleString('en-US'); }
  document.querySelectorAll('[data-ow2-calc]').forEach(function (root) {
    var wEl = root.querySelector('[data-calc-weight]');
    var hEl = root.querySelector('[data-calc-hours]');
    var wVal = root.querySelector('[data-calc-weight-val]');
    var hVal = root.querySelector('[data-calc-hours-val]');
    var stepsEl = root.querySelector('[data-calc-steps]');
    var calEl = root.querySelector('[data-calc-cal]');
    var paces = root.querySelectorAll('[data-calc-pace]');
    if (!wEl || !hEl) return;
    var met = 2.0;

    function calc() {
      var w = Number(wEl.value), h = Number(hEl.value);
      var kmh = met === 2.0 ? 2 : 3;
      var steps = Math.round(kmh * h * 1320 / 10) * 10;
      var cal = Math.round(met * w * h);
      if (wVal) wVal.textContent = w;
      if (hVal) hVal.textContent = h;
      if (stepsEl) stepsEl.textContent = fmt(steps);
      if (calEl) calEl.textContent = fmt(cal);
    }

    wEl.addEventListener('input', calc);
    hEl.addEventListener('input', calc);
    paces.forEach(function (btn) {
      btn.addEventListener('click', function () {
        met = Number(btn.getAttribute('data-calc-pace'));
        paces.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        calc();
      });
    });
    calc();
  });
})();
